import classNames from 'classnames'
import { PropsWithChildren } from 'react'

import styles from './StyledWrapper.module.scss'

interface IProps extends PropsWithChildren {
  classes?: { popup?: string }
}
export const StyledWrapper = ({ children, classes }: IProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={classNames(styles.popup, classes?.popup)}>{children}</div>
      </div>
    </div>
  )
}
